import React from "react";
import { ResponsiveContainer, AreaChart, Area, YAxis, Tooltip, CartesianGrid } from "recharts";
import { formatMoneyIntl } from "../../lib/formatMoney";
import { CHART_GRID, CHART_TICK, CHART_TOOLTIP, CHART_SERIES } from "./chartTheme";
import { formatDayLong, formatCompactMoney } from "./chartFormat";
import DayXAxis from "./DayXAxis";

/**
 * Revenue per UTC day in ONE currency. `series` is `[{date: "YYYY-MM-DD", cents: int}]`,
 * dense from the server (a day with no sale is a zero point). The kit holds no copy: the
 * caller passes `label` (the accessible name) and decides the empty state.
 */
export default function DailyRevenueChart({ series, currency, lang, label, height = 240, testid }) {
  return (
    <div role="img" aria-label={label} data-testid={testid}>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={series}>
          <CartesianGrid {...CHART_GRID} />
          <DayXAxis dates={series.map((p) => p.date)} lang={lang} />
          <YAxis tick={CHART_TICK} width={64} tickFormatter={(v) => formatCompactMoney(v, currency, lang)} />
          <Tooltip
            {...CHART_TOOLTIP}
            labelFormatter={(d) => formatDayLong(d, lang)}
            formatter={(v) => [formatMoneyIntl(v, currency, lang), label]}
          />
          <Area type="monotone" dataKey="cents" name={label} stroke={CHART_SERIES.revenue}
            fill={CHART_SERIES.revenue} fillOpacity={0.2} strokeWidth={2} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
